import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../../helpers/getBaseProductType';
import { getHoneycombRailHexColour } from '../../../../helpers/getHexColorCode';
import { getProductType } from '../../../../helpers/getProductType';
import { LiftPosition } from '../LiftPosition';
import { ChainImage } from './DriveControlImages/Chain';
import { CordedImage } from './DriveControlImages/Corded';
import { CordloopImage } from './DriveControlImages/CordLoop';
import { LiftControl } from './DriveControlImages/TiltControl';
import { WandImage } from './DriveControlImages/Wand';

type Props = {
  top: number | string;
  driveControlRight: number | string;
  windowFrameHeight: number;
  windowFrameWidth: number;
  windowWidth: number;
  windowHeight: number | string;
  menuHeight: number;
  headRailPosition:
    | string
    | {
        top: string | number;
        right: string | number;
        left: string | number;
        bottom: string | number;
      };
};

const Wrapper = styled.div<{
  top: number | string;
  driveControlRight: number | string;
  windowFrameHeight: number;
  windowFrameWidth: number;
  windowHeight: number | string;
  windowWidth: number;
  driveControl: any;
  driveControlSide: string;
  headRailPositionTop: string | number;
  isHoneycomb: boolean;
  isRollerBlind: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 5;
  width: 10px;
  ${({
    driveControlRight,
    windowFrameWidth,
    driveControlSide,
    isRollerBlind,
  }) => {
    const widthMargin = isRollerBlind === true ? 5 : 10;
    const right =
      driveControlRight !== '' &&
      typeof driveControlRight === 'number' &&
      windowFrameWidth === 0
        ? driveControlRight - widthMargin
        : driveControlRight !== '' &&
          typeof driveControlRight === 'number' &&
          windowFrameWidth !== 0
        ? driveControlRight - windowFrameWidth + 7
        : '';
    return right !== '' && driveControlSide === 'Right'
      ? `left: ${right}px;`
      : `right: ${right}px;`;
  }};

  ${({
    top,
    windowFrameHeight,
    headRailPositionTop,
    isHoneycomb,
    isRollerBlind,
  }) => {
    const additionalTopMargin = isHoneycomb ? 3 : isRollerBlind ? 6 : 0;
    const cordTopPosition =
      Number(headRailPositionTop) !== 0
        ? Number(headRailPositionTop)
        : typeof top === 'number' && windowFrameHeight
        ? top + windowFrameHeight / 2 + additionalTopMargin
        : typeof top === 'number' &&
          !windowFrameHeight &&
          (isHoneycomb || isRollerBlind)
        ? top + additionalTopMargin
        : top;
    return cordTopPosition !== '' ? `top: ${cordTopPosition}px;` : '';
  }};

  ${({ windowHeight }) => {
    const height =
      windowHeight !== 'auto' && typeof windowHeight === 'number'
        ? windowHeight * 0.75
        : '';
    return `height: ${height}px`;
  }};
  
  @media (min-width: 1024px) and (max-width: 1440px) {
    // height: 319px!important;
    // top: 8.3%!important;
    // left: 50.2%!important;
    // transform: translateX(-50%);
    // width: 425px !important;
    // justify-content: flex-end!important;
  }
  @media (min-width: 1441px) and (max-width: 1960px) {
    // height: 351.89px!important;
    // top: 9.3%!important;
    // left: 50.2%!important;
    // transform: translateX(-50%);
    // width: 475px !important;
    // justify-content: flex-end!important;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    // height: 351.89px!important;
    // top: 9.3%!important;
    // left: 50.2%!important;
    // transform: translateX(-50%);
    // width: 505px !important;
    // justify-content: flex-end!important;
  }
  @media (max-width: 767px) {
    // height: 250.89px!important;
    // top: 14.3%!important;
    // left: 50.2%!important;
    // transform: translateX(-50%);
    // width: 297px !important;
    // justify-content: flex-end!important;
  }
  @media (max-width: 374px) {
    // height: 210.89px!important;
    // width: 248px!important;
  }
`;

export const DriveControlImage = ({
  top,
  driveControlRight,
  windowFrameHeight,
  windowFrameWidth,
  windowWidth,
  windowHeight,
  headRailPosition,
  menuHeight,
}: Props) => {
  const [state] = useService(productBuilderMachine);
  const productType = getBaseProductType(state.context);
  const subProductType = getProductType(state.context);
  const liftPosition = state.context.custom.liftPosition
    ? state.context.custom.liftPosition
    : '';

  const isVenetianTimberOrPVC =
    productType === 'Venetian' && subProductType !== 'Venetian Aluminium'
      ? true
      : productType === 'Venetian' && subProductType === 'Venetian Aluminium'
      ? false
      : null;

  const driveControl = state.context.custom.driveControl
    ? state.context.custom.driveControl
    : state.context.custom.tiltControl
    ? state.context.custom.tiltControl
    : '';
  const height =
    windowHeight !== 'auto' && typeof windowHeight === 'number'
      ? windowHeight * 0.75
      : '';

  const driveControlSide = state.context.custom.chainPosition
    ? state.context.custom.chainPosition
    : state.context.custom.cordPosition
    ? state.context.custom.cordPosition
    : state.context.custom.tiltPosition
    ? state.context.custom.tiltPosition
    : subProductType &&
      subProductType.includes('Honeycomb Standard') &&
      state.context.custom.liftPosition
    ? state.context.custom.liftPosition
    : 'Right';
  const tiltPosition = state.context.custom.tiltPosition
    ? state.context.custom.tiltPosition
    : '';

  const liftPositionMarginRight =
    liftPosition !== '' &&
    driveControlSide !== liftPosition &&
    typeof driveControlRight === 'number' &&
    windowFrameWidth === 0
      ? windowWidth - 10
      : liftPosition !== '' &&
        driveControlSide !== liftPosition &&
        typeof driveControlRight === 'number' &&
        windowFrameWidth !== 0
      ? windowWidth - windowFrameWidth - 10
      : '';

  const liftPositionRight =
    liftPosition !== 'Left' && liftPositionMarginRight !== ''
      ? `${liftPositionMarginRight}px`
      : 'auto';
  const liftPositionLeft =
    liftPosition === 'Left' && liftPositionMarginRight !== ''
      ? `${liftPositionMarginRight}px`
      : 'auto';

  const isHoneycomb = window.location.pathname.includes('honeycomb');

  const headRailPositionTop =
    headRailPosition &&
    typeof headRailPosition === 'object' &&
    !isHoneycomb &&
    productType !== 'Venetian'
      ? Number(headRailPosition.top) - menuHeight
      : headRailPosition &&
        typeof headRailPosition === 'object' &&
        !isHoneycomb &&
        productType === 'Venetian'
      ? Number(headRailPosition.top) - menuHeight - 3
      : 0;

  const rollerDayNightMarginRight =
    windowFrameWidth === 0 ? windowWidth : windowWidth - windowFrameWidth - 3;

  const honeycombDayNightMarginRight =
    windowFrameWidth === 0
      ? windowWidth - 10
      : windowWidth - windowFrameWidth - 20;

  return (
    <Wrapper
      top={top}
      driveControlRight={driveControlRight}
      windowFrameHeight={windowFrameHeight}
      windowFrameWidth={windowFrameWidth}
      windowWidth={windowWidth}
      windowHeight={windowHeight}
      driveControl={driveControl}
      driveControlSide={driveControlSide}
      headRailPositionTop={headRailPositionTop}
      isHoneycomb={isHoneycomb}
      isRollerBlind={productType === 'Roller Blind' ? true : false}
    >
      {(driveControl === 'Drive Control: Corded' ||
        driveControl === 'Cord' ||
        isVenetianTimberOrPVC) && <CordedImage height={height} width="7px" />}
      {(driveControl === 'Drive Control: Corded' || driveControl === 'Cord') &&
        (subProductType === 'Honeycomb Day/Night Corded' ||
          subProductType === 'Honeycomb Dual View Corded') && (
          <CordedImage
            height={height}
            width="7px"
            style={{
              position: 'relative',
              right: honeycombDayNightMarginRight,
            }}
          />
        )}
      {driveControl === 'Drive Control: Cordloop' && (
        <CordloopImage height={height} style={{ position: 'absolute' }} />
      )}
      {driveControl === 'Wand' && <WandImage height={height} width="5px" />}
      {liftPosition !== '' &&
        subProductType &&
        !subProductType.includes('Honeycomb Standard') && (
          <LiftControl
            height={height}
            style={{
              left: liftPositionRight,
              right: liftPositionLeft,
              position:
                driveControlSide !== liftPosition ? 'absolute' : 'relative',
            }}
            width="7px"
          />
        )}
      {driveControl === 'Drive Control: Chain' && (
        <ChainImage height={height} width="3px" />
      )}
      {driveControl === 'Drive Control: Chain' &&
        subProductType === 'Roller Blind Day/Night Chain' && (
          <ChainImage
            height={height}
            width="3px"
            style={{ position: 'absolute', right: rollerDayNightMarginRight }}
          />
        )}
    </Wrapper>
  );
};
